
import Footer from './components/v2/Footer.js';

import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import Home from "./pages/Home";
import About from './pages/About.js';

import Menu from './components/v2/Menu.js';
import './App.css';

function App() {
	return (
		<Router>
			<Menu/>
			<Routes>
				<Route path="/" element={<Home/>}/>
				<Route path="/about" element={<About/>}/>
			</Routes>
			<Footer/>
		</Router>
	);
}

export default App;
